import { LegacyRef, PropsWithRef, forwardRef } from 'react';
import { Textarea as JuicyTextarea } from '@vtbhome/juicyfront';
import { TextareaProps } from './types';
import { StyledFormGroup } from './textarea.styles';
import { ErrorMessageInput } from '../error-message-input/error-message-input';

export const Textarea = forwardRef(
    (
        { value, error, label, hint, maxLength, ...props }: PropsWithRef<TextareaProps>,
        ref: LegacyRef<HTMLTextAreaElement>
    ) => {
        return (
            <StyledFormGroup
                label={label}
                required={props.required}
                $error={error}
                $currentLength={value?.length || 0}
                $maxLength={maxLength}
                errorMessage={<ErrorMessageInput error={error} hint={hint} />}>
                <JuicyTextarea ref={ref} value={value} invalid={Boolean(error)} maxLength={maxLength} {...props} />
            </StyledFormGroup>
        );
    }
);

Textarea.displayName = 'Textarea';
